module.exports = __webpack_public_path__ + "img/mobile-product-case-banner-technology.e275cbb1.png";